export default "__VITE_ASSET__2c05c864__"